import BaseView from "../../../js/base-view";
import splitButtonTextIntoLetters from "../../../js/utils/splitTextIntoLetters";

export default class Button extends BaseView {
	init() {
		// Split text into words and letters for animation
		this.splitTextIntoLetters();
	}

	splitTextIntoLetters() {
		// Find the button/link element - could be .wp-block-button__link__inner (styleguide) or .wp-block-button__link (WordPress core)
		let button = this.el.querySelector(".wp-block-button__link__inner");

		// If not found, try WordPress core/button structure (.wp-block-button__link without __inner)
		if (!button) {
			button = this.el.querySelector(".wp-block-button__link");
		}

		// If not found, check if this.el itself has the button class (for <button> elements)
		if (!button && this.el.classList.contains("wp-block-button")) {
			button = this.el;
		}

		if (!button) return;

		// Check parent for excluded button types
		const parent = button.closest(".wp-block-button");
		if (parent?.classList.contains("button--icon")) return;

		// Check if the button has already been initialized
		if (button.dataset.initialized) return;

		// Set the initialized flag
		button.dataset.initialized = true;

		splitButtonTextIntoLetters(button);
	}

	// destroy() {
	// }
}
